import { render, staticRenderFns } from "./SuppAddMain.vue?vue&type=template&id=f29e42f0&scoped=true&"
import script from "./SuppAddMain.vue?vue&type=script&lang=js&"
export * from "./SuppAddMain.vue?vue&type=script&lang=js&"
import style0 from "./SuppAddMain.vue?vue&type=style&index=0&id=f29e42f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29e42f0",
  null
  
)

export default component.exports